import { render, staticRenderFns } from "./AmountPaymentTab.vue?vue&type=template&id=e80c49f2&scoped=true&"
import script from "./AmountPaymentTab.vue?vue&type=script&lang=ts&"
export * from "./AmountPaymentTab.vue?vue&type=script&lang=ts&"
import style0 from "./AmountPaymentTab.vue?vue&type=style&index=0&id=e80c49f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80c49f2",
  null
  
)

export default component.exports